import FirstUpper from '../FirstUpper';
import { useAppContext } from '../../Services/AppContext';
import { Order } from './CaseChatEntry';
import CaseChatEntryOrderItem from './CaseChatEntryOrderItem';
import CaseChatEntryOrderTotal from './CaseChatEntryOrderTotal';
import ApiClient from '../../Services/ApiClient';

interface CaseChatEntryOrderProps {
	order: Order;
	entryId: string;
	beforeChange: () => void;
	afterChange: () => void;
}

export default function CaseChatEntryOrder(props: CaseChatEntryOrderProps) {
	const { translation } = useAppContext();
	const { order, beforeChange, afterChange } = props;

	// @ts-ignore
	const handleCancelOrder = async () => {
		beforeChange();

		await ApiClient.delete('/order/' + order.id);

		afterChange();
	};

	return (
		<div className='chat-message__order'>
			<div className='chat-message__order__header'>
				<FirstUpper>
					{translation['component.caseActivityItemOrder.requestedPayment']}
				</FirstUpper>
			</div>
			<div className='chat-message__order__body'>
				{order.orderItems.map(item => (
					<CaseChatEntryOrderItem
						key={item.id}
						orderItem={item}
						orderId={order.id}
						showOrderItemPrice={order.orderItems.length > 1}
					/>
				))}
				<CaseChatEntryOrderTotal order={order} />
			</div>
			<div className='chat-message__order__footer'>
				{order.orderLog.value === 'CREATED' && (
					<a onClick={handleCancelOrder} className='btn-link red'>
						<FirstUpper>
							{
								translation[
									'component.caseActivityItemOrder.cancelPaymentRequest'
								]
							}
						</FirstUpper>
					</a>
				)}
				{order.orderLog.value === 'DONE' && (
					<div className='d-flex flex-row justify-content-between align-items-center'>
						<div className='d-flex flex-row payed mt-3 mb-2'>
							<img src='/dist/icons/v2/check-green.svg' alt='' height='20px' />
							<div className='ml-2'>
								<FirstUpper>{translation['base.payed']}</FirstUpper>
							</div>
						</div>
					</div>
				)}
				{order.orderLog.value === 'CANCELED' && (
					<div className='mt-3'>
						<FirstUpper>{translation['base.canceled']}</FirstUpper>
					</div>
				)}
			</div>
		</div>
	);
}
